import React, { ReactNode, useState } from 'react'
import { images } from '../../images'
import { StyledArrow, StyledTooltipContainer, StyledTooltipContent, StyledTooltipText } from './styles'

interface IProps {
  children?: ReactNode
}

export const Tooltip: React.FC<IProps> = ({ children }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false)
  const content = isTooltipVisible
    ? (
      <>
        <StyledTooltipContent>
          <div onMouseOver={ () => setIsTooltipVisible(true) }>
            <StyledTooltipText>
              { children }
            </StyledTooltipText>
          </div>
        </StyledTooltipContent>
        <StyledArrow />
      </>
      )
    : null

  return (
    <>
      <StyledTooltipContainer>
        <div
          onMouseOver={ () => setIsTooltipVisible(true) }
          onMouseOut={ () => setIsTooltipVisible(false) }
        >
          <img src={ images['info'] } alt="Info"/>
        </div>
      </StyledTooltipContainer>
      { content }
    </>
  )
}
